module.exports = __webpack_public_path__ + "img/border_Ellipse.db1601a3.svg";